var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogSocialMediaLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9534 29.9534H25.2239V21.678C25.2239 19.4078 24.2225 18.1413 22.4264 18.1413C20.472 18.1413 19.3121 19.461 19.3121 21.678V29.9534H14.5826V14.5826H19.3121V16.3111C19.3121 16.3111 20.7959 13.7074 24.1397 13.7074C27.4846 13.7074 29.9534 15.7486 29.9534 19.972V29.9534ZM9.19332 12.1243C7.5983 12.1243 6.30597 10.8214 6.30597 9.21459C6.30597 7.60893 7.5983 6.306 9.19332 6.306C10.7872 6.306 12.0795 7.60893 12.0795 9.21459C12.0807 10.8214 10.7872 12.1243 9.19332 12.1243ZM6.30597 29.9534H12.2178V14.5826H6.30597V29.9534Z",
    fill: "#787879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSocialMediaLinkedin);
export default __webpack_public_path__ + "static/media/blog-social-media-linkedin.20790aeb4910174bdc25e282ed18d836.svg";
export { ForwardRef as ReactComponent };